import module from "../helper/inject";

/** @type jQuery **/
const $ = module.$();

$(document).ready(() => {
    const coupon = $('[programme-coupon]');
});
